import { Navigate, Outlet } from "react-router-dom";

export default function AdminProtected() {
  const token = typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;
  if (!token) return <Navigate to="/adminia/login" replace />;
  return <Outlet />;
}
